<template>
    <div class="py-4"> 
        <div id="assessment-remaining-date" class="mb-5">
            <div class="mb-2 tail-line-dark-sm">
                {{ $t('남은 기간') }}
            </div>
            <b-skeleton v-if="is_nice_services_status_loaded !== true && !is_status_failed" width="60%" height="1.6rem"></b-skeleton>
            <div v-else-if="check_campaign_completed === false && left_days !== null && left_days < 0" class="f-90 red">
                {{ $t('마감되었습니다') }}
            </div>
            <div v-else-if="check_campaign_completed === false && left_days !== null"
                class="f-90"
                :class="[{ 'red': left_days < 1 }]"
                >
                <span class="f-160">{{ left_days }}</span>
                {{ $t('일') }}

                <span class="ml-1 f-160"> {{ left_time }}</span>
                {{ $t('시간') }}
            </div>
            <div v-else class="f-90 gray-550">
                - {{ $t('답변기간이 아닙니다') }} -
            </div>
        </div>

        <div id="assessment-submit" class="mb-5">
            <div class="mb-2 tail-line-dark-sm"> {{ $t('최종 제출하기') }} </div>
            <make-all-complete-button
                :btn_size="'sm'"
                :btn_variant="variant_by_filled_rate"
                :disable_status="status_code !== 'in_progress'"
                >
                <fa icon="flag" class="mr-1"></fa>
                <span v-if="status_code === 'requested'">{{ $t('미시작') }}</span>
                <span v-else-if="status_code === 'in_progress'">{{ $t('최종 제출하기') }}</span>
                <span v-else-if="status_code === 'in_assessment'">{{ $t('평가중') }}</span>
                <span v-else-if="status_code === 'canceled'">{{ $t('평가 취소') }}</span>
                <span v-else>{{ $t('평가완료') }}</span>
                <!-- {{ status_code === 'in_progress' ? $t('최종 제출하기') : $t('제출됨') }}
                {{ status_code === 'in_assessment'? $t('평가중') : ''}} -->
            </make-all-complete-button>

            <div v-if="overall_filled === true && check_campaign_completed === false"
                class="f-85 mt-2"
                :class="overall_filled === true ? 'red red-border' : 'gray-600'">
                <fa icon="info-circle" class="mr-1"></fa>
                {{ $t('답변을 모두 완료하셨다면 최종 제출하기를 클릭해주세요.') }}
            </div>
            <div v-else-if="check_campaign_completed === true" class="f-85 gray-600 mt-2">
                <fa icon="grin-alt" class="mr-1 f-90"></fa>
                {{ $t('제출되었습니다. 감사합니다.') }}
            </div>
        </div>

        <div v-if="!is_loading_participants" class="mb-5">
            <div class="mb-2 tail-line-dark-sm">{{ $t('참여자 리스트') }}</div>
            <div v-if="participants_error" class="f-85 gray-600">
                {{ $t('참여자를 불러오지 못했습니다.') }}
                <b-button variant="dark-border" size="sm" class="d-block mt-2" @click="getRequestParticipants">
                    <fa icon="redo" class="mr-1"></fa>{{ $t('다시 시도') }}
                </b-button>
            </div>
            <div v-else id="participant-list" :class="[{ 'mb-2': is_manager }]">
                <div v-for="(participant, index) in participants"
                    :key="`company-user-${participant.id}`"
                    class="mb-2"
                    >
                    <p class="f-95 mb-0">{{ index + 1 }}. {{ participant.user.user_name }}
                        <b-badge :variant="participant.role === 2 ? 'primary' : 'basic'" class="ml-1"> 
                            <span v-if="participant.role === 2">
                                {{ $t('평가 관리자') }}
                            </span>
                            <span v-else-if="participant.role === 1 && participant.access_status === 0">
                                {{ $t('일반 참여자') }}
                            </span>
                            <span v-else>
                                {{ $t('접근 요청중') }}
                            </span>
                        </b-badge>
                    </p>
                    <p class="f-85 text-truncate mb-0 ml-3">{{ participant.user.e_mail }}</p>
                </div>
            </div>
            <div v-if="is_manager">
                <b-button
                    v-b-modal.user-registration
                    variant="dark-border"
                    size="sm"
                    >
                    <fa icon="user-plus" class="mr-1"></fa>
                    {{ $t('참여자 관리') }}
                </b-button>
            </div>
        </div>

        <div class="mb-5">
            <div class="mb-2 tail-line-dark-sm">{{ $t('첨부파일 관리') }}</div>
            <b-button v-b-modal.company-attachements-storage
                variant="dark-border"
                size="sm"
                >
                <BIconUpload class="mr-1"/>
                {{ $t('첨부파일 보관함') }}
            </b-button>
        </div>
        
        
        <div class="mb-2 tail-line-dark-sm">{{ $t('인쇄 및 다운로드') }}</div>
        <div v-if="isIE !== true" class="mb-5">
            <print-to-pdf :btn_size="'sm'">
                <fa icon="print" class="mr-1"></fa> {{ $t('인쇄 및 다운로드') }}
            </print-to-pdf>
        </div>

        <div v-else class="mb-5 border border-color-gray-400 bgray-300 rounded p-2 p-xl-3 f-85 gray-600">
            <fa icon="info-circle" class="mr-1"></fa>
            {{ $t('인터넷 익스플로러에서는 인쇄 및 다운로드를 사용하실 수 없습니다. 크롬(Chrome) 또는 엣지(Edge) 브라우저를 사용해주세요.') }} 
        </div>

        <b-modal id="company-attachements-storage" size="xl" :title="$t('첨부파일 보관함')" hide-footer scrollable>
            <AttachmentsStorage />
        </b-modal>
        
        <template v-if="is_manager">
            <b-modal id="user-registration" size="lg" :title="$t('참여자 관리')" hide-footer scrollable>
                <user-registration-form
                    :users_in_company="participants"
                    :is_manager="is_manager"
                    @update-user="updateUser"
                    @update-members="updateMembers"
                    />
            </b-modal>
        </template>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations} from 'vuex';
import PrintToPDF from '@core_components/common/PrintToPDF';
import MakeAllCompleteButton from '@shared_components/client/components/MakeAllCompleteButton';
import UserRegistrationForm from '@shared_components/client/components/UserRegistrationForm_v2';
import AttachmentsStorage from '@shared_components/client/components/AttachmentsStorage';
import {checkAppEnv} from '@shared/utils/common';

export default {
    components: {
        'print-to-pdf': PrintToPDF,
        MakeAllCompleteButton,
        UserRegistrationForm,
        AttachmentsStorage
    },
    data () {
        return {
            is_loading_participants: true,
            participants: [],
            participants_error: false,
            is_status_failed: false
        };
    },
    computed:{
        ...mapState(['campaign_in_progress', 'is_admin', 'company_id', 'user_id']),
        ...mapState('campaign_users', ['users_in_company']),
        ...mapState('industry_campaigns', ['nice_services_status', 'is_nice_services_status_loaded', 'total_filled_rate', 'is_filled_rate_loaded']),
        ...mapState({
            status_code: state => state.campaign_in_progress.status_code
        }),
        check_campaign_completed () {
            if (this.campaign_in_progress.campaign_state === '답변중' && this.status_code === 'in_progress') {
                return false;
            } else if (this.status_code === 'in_assessment') {
                return true;
            } else if (this.status_code === 'completed') {
                return true;
            } else {
                return null;
            }
        },
        left_days () {
            if (this.is_nice_services_status_loaded == true && this.nice_services_status.length) {
                if (this.isIE === true) {
                    let txt_date = this.nice_services_status[0].duedate_ts.replace('-', '/');
                    let gap = new Date(txt_date).getTime() - new Date().getTime();
                    return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수
                } else {
                    let gap = new Date(this.nice_services_status[0].duedate_ts).getTime() - new Date().getTime();
                    return Math.floor(gap / (1000 * 60 * 60 * 24)); // 남은 일수 
                }
            } else {
                return null;
            }            
        },
        left_time () {
            if (this.is_nice_services_status_loaded == true && this.nice_services_status.length) {
                if (this.isIE === true) {
                    let txt_date = this.nice_services_status[0].duedate_ts.replace('-', '/');
                    let time_gap = new Date(0, 0, 0, 0, 0, 0, new Date(txt_date) - new Date()); 
                    return time_gap.getHours(); // 남은 시간
                } else {
                    let time_gap = new Date(0, 0, 0, 0, 0, 0, new Date(this.nice_services_status[0].duedate_ts) - new Date()); 
                    return time_gap.getHours(); // 남은 시간
                }
            } else {
                return null;
            }
        },
        overall_filled() {
            if (this.is_filled_rate_loaded == true && this.total_filled_rate.length) {
                if ((this.total_filled_rate[0].filled_rate*100) >80){
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        variant_by_filled_rate(){
            if (this.is_filled_rate_loaded == true) {
                if (this.overall_filled == true && this.status_code == 'in_progress') {
                    return 'red-blinking';
                } else {
                    return (checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply') ? 'primary' : 'outline-dark';
                }
            } else {
                return (checkAppEnv() === 'ksteel' || checkAppEnv() === 'supply') ? 'primary' : 'outline-dark';
            }
        },
        is_manager () {
            const _me = (this.participants || []).find(_participant => _participant.user_id === Number(this.user_id));
            return _me?.role === 2;
        },
        filled_rate_target () {
            return `${this.$route.query.cmp}|${this.$route.query.cpn}`;
        },
        number_of_completed_questions () {
            return this.$store.getters.getNumberOfCompletedQuestions;
        }
    },
    watch:{
        // 작성률은 평가 대상마다 한 번 읽고, 완료 체크 수가 바뀔 때 다시 읽는다 (문항 이동마다 읽지 않음)
        // ponytail: 답변만 저장하고 완료 체크를 안 하면 다음 완료 체크·재진입 때 갱신된다. 즉시 필요하면 questions/update_sub 구독
        filled_rate_target: {
            immediate: true,
            handler () {
                this.refreshFilledRate();
            }
        },
        number_of_completed_questions () {
            this.refreshFilledRate();
        }
    },
    async created () {
        this.update_nice_service_status_loaded(false); // 이전 평가의 마감일이 잠깐 보이지 않게
        try {
            await this.readNiceServiceStatus({
                campaign_id: this.$route.query.cmp,
                company_id: this.$route.query.cpn
            });
        } catch (error) {
            if (error?.response?.status === 401) return;
            this.is_status_failed = true;
            // 도구 패널은 상태 없이도 쓸 수 있으므로 안내만 하고 계속 진행한다
            this.$EventBus.$emit('toast-warning', this.$t('알림'), this.$t('평가 참여 정보를 불러오지 못했습니다. 일부 정보가 표시되지 않을 수 있습니다.'));
        }

        // if (!this.users_in_company || !this.users_in_company.length) {
        //     await this.readUsersByCompany(this.company_id)    
        // }

        await this.getRequestParticipants();
    },
    beforeDestroy(){
        this.update_filled_rate_loaded(false);
    },
    methods:{
        ...mapMutations('industry_campaigns', ['update_filled_rate_loaded', 'update_nice_service_status_loaded']),
        ...mapActions('industry_campaigns', ['readNiceServiceStatus', 'readFilledRate']),
        ...mapActions('campaign_users', ['readUsersByCompany']),
        refreshFilledRate () {
            const { cmp, cpn } = this.$route.query;
            if (!cmp || !cpn) return;
            this.readFilledRate({ campaign_id: cmp, company_id: cpn });
        },
        async getRequestParticipants () {
            try {
                this.is_loading_participants = true;
                this.participants_error = false;
                const res_member = await this.$axios.get('/company/members', {
                    params: {
                        company_id: this.$route.query.cpn,
                        campaign_id: this.$route.query.cmp
                    }
                });
                this.participants = res_member.data.sort((a, b) => b.role - a.role);
            } catch (e) {
                if (e?.response?.status === 401) return;
                // 빈 목록으로 두면 '참여자 관리' 버튼이 사라져 기능이 없어진 것처럼 보인다
                this.participants_error = true;
            } finally {
                this.is_loading_participants = false;
            }
        },
        checkUserExcluded(user_excluded_campaigns){
            if (user_excluded_campaigns) {
                let excluded_idx = user_excluded_campaigns.findIndex( exc => exc == this.campaign_in_progress.campaign_name);
                return excluded_idx > -1;
            } else {
                return false;
            }
        },
        // POST /users/role 응답은 Users(id, is_admin …)라 참여자의 user 안에 합친다
        updateUser (updatedUser) {
            const idx = this.participants.findIndex(({ user_id }) => user_id === updatedUser?.id);
            if (idx > -1) {
                const participant = this.participants[idx];
                this.participants.splice(idx, 1, { ...participant, user: { ...participant.user, ...updatedUser } });
            }
        },
        updateMembers (updatedMembers) {
            this.participants = updatedMembers.sort((a, b) => b.role - a.role);
        }
    }
};
</script>

<style>

</style>
